module.exports = __webpack_public_path__ + "static/media/AwsCloud.390ca811.gif";